import { render, staticRenderFns } from "./SendInvoices.vue?vue&type=template&id=3062a525&"
import script from "./SendInvoices.vue?vue&type=script&lang=js&"
export * from "./SendInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports